import React from 'react'
import { DragDropContext, Droppable } from 'react-beautiful-dnd'
import { useTranslation } from 'react-i18next'
import { produce } from 'immer'

import Button from 'js/components/Button/Button'
import { H4 } from 'js/components/Heading'
import hashString from 'js/lib/helpers/hashString'

import InsertFromContentHeader from './InsertFromContentHeader'
import InsertFromContentItem from './InsertFromContentItem'

const InsertFromContentItems = ({ items, setItems, onInsertLinks }) => {
    const { t } = useTranslation()

    const onDragEnd = (result) => {
        if (!result.destination) return

        const sourcePosition = result.source.index
        const destinationPosition = result.destination.index

        setItems(
            produce((newState) => {
                const [movedItem] = newState.splice(sourcePosition, 1)
                newState.splice(destinationPosition, 0, movedItem)
            }),
        )
    }

    return (
        <>
            <InsertFromContentHeader>
                <H4>
                    {t('global.count-items', {
                        count: items.length,
                    })}
                </H4>
                {items.length > 0 && (
                    <Button
                        size="normal"
                        variant="primary"
                        onClick={onInsertLinks}
                        style={{
                            marginLeft: 'auto',
                        }}
                    >
                        {t('widget-linklist.insert-item', {
                            count: items.length,
                        })}
                    </Button>
                )}
            </InsertFromContentHeader>
            <DragDropContext onDragEnd={onDragEnd}>
                <Droppable droppableId="link-list-search-results-items">
                    {(provided) => (
                        <>
                            <ul ref={provided.innerRef}>
                                {items.map((entity, i) => {
                                    const removeItem = () => {
                                        setItems(
                                            produce((newState) => {
                                                newState.splice(i, 1)
                                            }),
                                        )
                                    }

                                    return (
                                        <InsertFromContentItem
                                            key={hashString(
                                                `${entity.guid}-draggable`,
                                            )}
                                            index={i}
                                            entity={entity}
                                            onRemove={removeItem}
                                        />
                                    )
                                })}
                            </ul>
                            {provided.placeholder}
                        </>
                    )}
                </Droppable>
            </DragDropContext>
        </>
    )
}

export default InsertFromContentItems
